<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Input Aktiva {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2" color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
          <div>
          <vs-row>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">  
            <label class="vs-input--label">TGL PEROLEHAN *</label>
            <div class="vs-con-input">
            <date-picker
            v-model="formdata.tanggal"
            format="DD-MM-YYYY"
            value-type="format"
            placeholder="Pilih Tgl" input-class="vs-input--input">
            </date-picker>
            </div>
            </div>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" vs-sm="4"> 
              <vs-input label="NO BUKTI / VOUCHER" class="w-100 mt-4" v-model="formdata.nmr_bukti" /> 
             </vs-col>
          <vs-col vs-lg="5" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="KELOMPOK AKTIVA (KODE PERKIRAAN) *" autocomplete ref="perkiraan" v-model="formdata.kode">
            <vs-select-item
                :key="index"
               :value="item.kode_perk"
                :text="parseNama(item.nama)"
                v-for="(item,index) in optjenisAktiva"
            />    
            </vs-select> 
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" vs-sm="4"> 
              <vs-input label="KODE ASSET" class="w-100 mt-4" v-model="formdata.kode_asset" v-currency="options"/> 
             </vs-col>
          </vs-row>
          <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <vs-select class="w-100 mt-4" label="GOLONGAN TARIF (FISKAL) *" autocomplete ref="golongan" v-model="formdata.gol">
                    <vs-select-item
                        :key="index"
                        :value="item.gol"
                        :text="formatGolText(item)"
                        v-for="(item,index) in optGol"
                    />    
                </vs-select>
              </vs-col>
              <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
                <vs-input label="MASA (TAHUN)" disabled class="w-100 mt-4" v-model="formdata.masa" /> 
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                <vs-input label="TARIF %" disabled class="w-100 mt-4" :value="formdata.tarif ? formdata.tarif + '%' : '0%'" /> 
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                <vs-input label="METODE SUSUT" disabled class="w-100 mt-4" v-model="formdata.metode" /> 
              </vs-col>
          </vs-row>
          <vs-row>
             <vs-col vs-lg="12" vs-xs="12" vs-sm="12"> 
              <vs-textarea label="URAIAN / KETERANGAN ASET *" ref="uraian" v-model.lazy="formdata.uraian" class="mt-4 w-100" />
             </vs-col>
          </vs-row>
          <vs-row>
             <vs-col vs-lg="2" vs-xs="12" vs-sm="4"> 
                 <vs-input label="SATUAN *" :disabled="enable_edit" class="w-100 mt-1" v-model="formdata.satuan" placeholder="Contoh: Unit, Pcs" /> 
             </vs-col>
             <vs-col vs-lg="3" vs-xs="12" vs-sm="4"> 
                 <vs-input label="JUMLAH *" :disabled="enable_edit" class="w-100 mt-1" v-model="formdata.jumlah" v-currency="options"/> 
             </vs-col>
             <vs-col vs-lg="3" vs-xs="12" vs-sm="4"> 
                 <vs-input label="HARGA SATUAN *" :disabled="enable_edit" class="w-100 mt-1" v-model="formdata.harga_unit" v-currency="options"/> 
             </vs-col>
             <vs-col vs-lg="4" vs-xs="12" vs-sm="4"> 
                 <vs-input label="TOTAL HARGA BELI" disabled class="w-100 mt-1 font-weight-bold" v-model="formdata.harga_beli" v-currency="options"/> 
             </vs-col>
          </vs-row>

          <!-- OPSI PENCATATAN HUTANG / ACCOUNT PAYABLE -->
          <div class="hutang-container mt-4 pt-3">
            <div class="d-flex align-items-center mb-3">
              <vs-switch v-model="formdata.is_hutang" color="warning" />
              <span class="ml-3 font-weight-bold text-dark switch-label" @click="formdata.is_hutang = !formdata.is_hutang">
                Catat sebagai Hutang yang Harus Dibayar (Account Payable)
              </span>
              <span v-if="formdata.is_hutang" class="badge badge-warning ml-2 text-dark font-weight-normal px-2 py-1" style="font-size: 11px;">
                Hutang Aktif
              </span>
            </div>

            <transition name="fade">
              <div v-if="formdata.is_hutang" class="hutang-card p-3 mb-2 rounded border">
                <div class="d-flex align-items-center mb-1 text-primary font-weight-bold" style="font-size: 13px;">
                  <i class="material-icons mr-1" style="font-size: 18px; vertical-align: middle;">receipt_long</i>
                  <span>Rincian Hutang Usaha (Otomatis masuk ke Account Payable & Jurnal Hutang)</span>
                </div>
                <small class="text-muted d-block mb-3">
                  Sistem akan otomatis mencatat hutang ke modul Account Payable dan membuat jurnal berpasangan (Debit: Aset Tetap, Kredit: Hutang Usaha).
                </small>

                <vs-row>
                  <vs-col vs-lg="4" vs-xs="12" vs-sm="6">
                    <vs-select class="w-100 mt-2" label="SUPPLIER / REKANAN *" autocomplete v-model="formdata.sup_id" @change="onSelectSupplier">
                      <vs-select-item
                        :key="index"
                        :value="item.kode"
                        :text="item.kode + ' - ' + item.nama"
                        v-for="(item,index) in optRekanan"
                      />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                    <vs-select class="w-100 mt-2" label="JENIS HUTANG *" v-model="formdata.jenis_hutang">
                      <vs-select-item value="lokal" text="Hutang Usaha Lokal (COA 200)" />
                      <vs-select-item value="impor" text="Hutang Usaha Impor (COA 201)" />
                    </vs-select>
                  </vs-col>
                  <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                    <div class="vs-component vs-con-input-label vs-input w-100 mt-2 vs-input-primary">
                      <label class="vs-input--label">TGL JATUH TEMPO</label>
                      <div class="vs-con-input">
                        <date-picker
                          v-model="formdata.jatuh_tempo"
                          format="DD-MM-YYYY"
                          value-type="format"
                          placeholder="Pilih Tgl Jatuh Tempo"
                          input-class="vs-input--input"
                        />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col vs-lg="2" vs-xs="12" vs-sm="6">
                    <vs-input label="NO FAKTUR PAJAK" class="w-100 mt-2" v-model="formdata.nomor_fp" placeholder="Nomor FP (opsional)" />
                  </vs-col>
                </vs-row>
              </div>
            </transition>
          </div>
          
          </div>
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { CurrencyDirective, parseCurrency } from 'vue-currency-input'
  import _ from 'lodash'

  export default {
    components: {
      DatePicker,
    },
    directives: {
        currency: CurrencyDirective
    },
    data: function () {
      return {
        // eslint-disable-next-line
        locale: 'de',
        currency: null,
        datetrans: '',
        formdata: {
            tanggal:'',
            nmr_bukti:'',
            kode:'',
            kode_asset:'',
            uraian:'',
            satuan:'',
            jumlah:'0',
            harga_unit:'0',
            harga_beli:'',
            gol:'',
            masa:'',
            tarif:'',
            metode:'',
            opr:'',
            posting:'0',
            isEdit: false,
            prevReferensi:'',
            is_hutang: false,
            sup_id: '',
            nama_supplier: '',
            jenis_hutang: 'lokal',
            jatuh_tempo: '',
            nomor_fp: '',
        },
        enable_edit: false,
        optjenisAktiva:[],
        optGol:[],
        optRekanan:[],
        errors:[],
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        formatGolText: function(item){
            if (!item) return '';
            if (item.gol === 'TD' || parseFloat(item.tarif) === 0) {
                return `[${item.gol}] ${item.uraian} - (Tidak Disusutkan)`;
            }
            const masaText = item.masa ? `${item.masa} Thn` : '';
            const tarifText = `${parseFloat(item.tarif)}%`;
            return `[${item.gol}] ${item.uraian} - ${masaText} (${tarifText})`;
        },
        onSelectSupplier: function(){
            let selected = this.optRekanan.find(item => item.kode === this.formdata.sup_id);
            if (selected) {
                this.formdata.nama_supplier = selected.nama;
            }
        },
        getAllData: async function(){
            let kodeAwal = '160';
            let kodeAkhir = '185';

            try {
                let paramRes = await this.$http.get('/api/param-aset-range');
                if (paramRes.data && paramRes.data.kode_awal) {
                    kodeAwal = paramRes.data.kode_awal;
                    kodeAkhir = paramRes.data.kode_akhir;
                }
            } catch (e) {
                console.warn('Gagal memuat param-aset-range, menggunakan fallback 160-185');
            }

            this.$http.get('/api/perkiraan').then(response => {
                this.optjenisAktiva = response.data.filter(item =>{
                    return item.kode_perk >= kodeAwal && item.kode_perk <= kodeAkhir;
                });
            }).catch(error=>{
                console.error(error);
            });

            this.$http.get('/api/tarif').then(response => {
                this.optGol = response.data;
            }).catch(error=>{
                console.error(error);
            });

            this.$http.get('/api/rekanan').then(response => {
                this.optRekanan = response.data;
            }).catch(error=>{
                console.error(error);
            });

            // edit mode init data
            if(this.$route.params.ref != null){
                this.formdata.isEdit = true
                this.$http.get("/api/aktiva/"+this.$route.params.ref).then(response => {
                    const keys = Object.keys(response.data)
                    for(const key of keys){
                        if (this.formdata.hasOwnProperty(key)) {
                            if (key === 'is_hutang') {
                                this.formdata.is_hutang = (response.data[key] == 1 || response.data[key] === true);
                            } else {
                                this.formdata[key] = response.data[key];
                            }
                        }
                        if(key == 'asset_id'){
                            this.formdata.prevReferensi = response.data[key];
                        }
                        if(key == 'rekanan' && response.data[key] && response.data[key] !== '000' && response.data[key] !== '-') {
                            this.formdata.sup_id = response.data[key];
                        }
                        if(key == 'posting'){
                            if(response.data[key]==1)
                                this.enable_edit = true;
                            else
                                this.enable_edit = false;
                        }
                    }
                }).catch(error=>{
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                });
            }

            this.formdata.opr = this.$store.getters.getUserName
        },
        parseNama: function(nama){
            if (!nama) return '';
            var parts = nama.split('+');
            if (parts.length > 1) {
                return parts[0].replace(/=/g, '\u00a0') + parts[1];
            }
            return nama;
        },
        numberValue (value) {
            if (!value) return 0;
            return parseCurrency(value.toString(), this.options) || 0;
        },
        checkForm:function(e) {
            this.errors = [];
            // cek dari client dulu...
            if(!this.formdata.tanggal || this.formdata.tanggal === ''){
                this.errors.push("Tanggal perolehan belum terisi...")
            }
            if(!this.formdata.kode || this.formdata.kode === ''){
                this.errors.push("Kelompok Aktiva belum terisi...")
            }
            if(!this.formdata.gol || this.formdata.gol === ''){
                this.errors.push("Golongan Tarif belum dipilih...")
            }
            if(!this.formdata.uraian || this.formdata.uraian === ''){
                this.errors.push("Uraian belum terisi...")
            }
            if(!this.formdata.satuan || this.formdata.satuan === ''){
                this.errors.push("Satuan belum terisi...")
            }
            if(!this.formdata.harga_beli || this.formdata.harga_beli === '0' || this.formdata.harga_beli === '0,00'){
                this.errors.push("Harga dan jumlah belum terisi...")
            }
            if(this.formdata.is_hutang && (!this.formdata.sup_id || this.formdata.sup_id === '')){
                this.errors.push("Supplier / Rekanan wajib dipilih jika dicatat sebagai hutang...")
            }

            if(this.errors.length > 0){
                this.handleError(null,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post('/api/aktiva',{
                    formdata : this.formdata
                }).then(response => {
                    this.handleSuccess();
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error && error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            if (error.response.data && error.response.data.errors) {
                                const keys = Object.keys(error.response.data.errors)
                                for(const key of keys){
                                    this.errors.push(error.response.data.errors[key][0])
                                }
                            } else if (error.response.data && error.response.data.error) {
                                this.errors.push(error.response.data.error)
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data aktiva berhasil disimpan..',color:'success'})
            this.$router.push({name : 'aktivalist'});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat detail kesalahan',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        },
    },
    computed: {
        options () {
            return {
                locale: this.locale,
                currency: this.currency
            }
        },
        jumlahDanHarga() {
          return `${this.formdata.jumlah}|${this.formdata.harga_unit}`;
        },
    },
    watch:{
        'formdata.gol': function(){
            let gol = this.formdata.gol;
            let objGol = this.optGol.find(item => item.gol === gol);
            if (objGol) {
                this.formdata.masa = objGol.masa != null ? objGol.masa : 0;
                this.formdata.tarif = objGol.tarif != null ? parseFloat(objGol.tarif) : 0;
                if (objGol.jenis === 'SLN') {
                    this.formdata.metode = 'Garis Lurus';
                } else if (objGol.jenis === 'DB') {
                    this.formdata.metode = 'Saldo Menurun';
                } else if (objGol.gol === 'TD' || !objGol.jenis) {
                    this.formdata.metode = 'Tidak Disusutkan';
                } else {
                    this.formdata.metode = objGol.jenis;
                }
            }
        },
        jumlahDanHarga(newVal) {
          const [newJumlah, newHarga] = newVal.split('|');
          let jumlah = this.numberValue(newJumlah);
          let harga = this.numberValue(newHarga);
          let harga_beli = jumlah * harga;
          this.formdata.harga_beli = new Intl.NumberFormat('de-DE',{notation: 'standard',}).format(harga_beli);
        },
    },
    mounted: function () {
        this.getAllData();
    },
  }
</script>

<style scoped>
.hutang-container {
  border-top: 1px solid #e2e8f0;
}
.switch-label {
  font-size: 14px;
  cursor: pointer;
}
.hutang-card {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>